import { makeStyles } from '@mui/styles';

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const useStyles = makeStyles((theme: any) => ({
  featureWrapper: {
    display: 'flex',
    fontWeight: 400,
    fontSize: theme.spacing(2),
    rowGap: theme.spacing(1),
    columnGap: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      rowGap: 0
    }
  },
  labelName: {
    display: 'flex',
    alignItems: 'center',
    flexGrow: 1,
    fontSize: '14px'
  },
  featureValue: {
    color: theme.palette.main
  },
  h4Root: {
    marginBottom: theme.spacing(2),
    textAlign: 'right'
  }
}));
